import { DefaultServerService } from '@affine/core/modules/cloud';
import { useService } from '@toeverything/infra';
import { type PropsWithChildren, useEffect, useState } from 'react';

export const ServerConfigGate = ({ children }: PropsWithChildren) => {
  const defaultServerService = useService(DefaultServerService);
  const [isServerReady, setIsServerReady] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    let disposed = false;

    defaultServerService.server
      .waitForConfigRevalidation(abortController.signal)
      .then(() => {
        if (!disposed) {
          setIsServerReady(true);
        }
      })
      .catch(error => {
        if (!disposed && !abortController.signal.aborted) {
          console.error(error);
          setIsServerReady(true);
        }
      });

    return () => {
      disposed = true;
      abortController.abort();
    };
  }, [defaultServerService]);

  return isServerReady ? children : null;
};
